export default "__VITE_PUBLIC_ASSET__041c3f7c__"